import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Nav } from "react-bootstrap";
import "./styles.css";

interface MenuItem {
  eventKey: string;
  label: string;
}

interface Props {
  items: MenuItem[];
}

export default function Menu({ items }: Props): JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();
  const { user_id } = useParams();

  const pathParts = location.pathname.toLowerCase().split("/");
  const activeKey = pathParts[pathParts.indexOf("edit") + 1] || "";

  const handleSelect = (eventKey: string | null) => {
    if (!eventKey) return;
    navigate(`/users/${user_id}/edit/${eventKey}`);
  };

  return (
    <>
      <h3 className="menu-title">User Profile</h3>
      <hr style={{ marginTop: "3px", marginBottom: "3px", width: "90%" }} />
      <Nav
        variant="pills"
        className="flex-column"
        activeKey={activeKey}
        onSelect={handleSelect}
      >
        {items.map((item) => (
          <Nav.Item key={item.eventKey} className="nav-item">
            <Nav.Link eventKey={item.eventKey} className="nav-link">
              {item.label}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
    </>
  );
}
